// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["vendors-admin-plugins","admin-plugins-styles"], () => (__webpack_require__("./sources/scss/admin/plugins.scss")))
__webpack_require__.O(undefined, ["vendors-admin-plugins","admin-plugins-styles"], () => (__webpack_require__("./node_modules/.pnpm/modaal@0.4.4/node_modules/modaal/dist/js/modaal.min.js")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendors-admin-plugins","admin-plugins-styles"], () => (__webpack_require__("./sources/ts/admin/plugins.ts")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
